import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { format } from 'date-fns';
import FourQuadrantCircle from './ColoredCircle';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const ClockContainer = styled.div`
  width: 300px;
  height: 300px;
  border-radius: 50%;
  border: 20px solid black;
  position: relative;
  margin: 25px auto;
  background-color: wheat;
`;

const ClockFace = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
`;

const Hand = styled.div`
  width: 44%;
  height: 3px;
  background-color: #333;
  position: absolute;
  top: calc(50% - 1.5px);
  left: calc(6%);
  transform-origin: 100%;
  transform: rotate(${props => props.rotation}deg);
  transition: all 0.05s;
  transition-timing-function: cubic-bezier(0.1, 2.7, 0.58, 1);
  border-radius: 2px;
`;

const Pan = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  animation: ${rotate} linear infinite;
  animation-duration: ${props => 60 / props.speed}s;
  overflow: hidden;
`;

const Dot = styled.div`
  position: absolute;
  top: 4px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #0000ff66;
`;

const AnalogClock = ({ locale, speed = 1 }) => {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDate(new Date());
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const formattedDate = format(date, 'HH:mm:ss', { locale });
  const [hours, minutes, seconds] = formattedDate.split(':');

  const secondsRotation = {
    rotation: `${90 + seconds * 6}`
  };
  const minutesRotation = {
    rotation: `${90 + minutes * 6}`
  };
  const hoursRotation = {
    // rotation: `${90 + (hours * 30) + (minutes * 0.5)}`
    rotation: `${90 + (hours * 15) + (minutes * 0.25)}`
  };

  return (
    <FourQuadrantCircle>
      <ClockFace />
      <Hand 
        className="hour-hand" 
        rotation={hoursRotation.rotation}
      />
      <Pan speed={speed}>
        <Dot />
      </Pan>
    </FourQuadrantCircle>
  );
};

export default AnalogClock;